import { z } from 'zod';
import type { ConfigDrivenProfileMessage } from './profile-message.js';

export const AccountSearchResultModel = z.object({
  id: z.string(),
  name: z.string(),
  address: z.string(),
});
export type AccountSearchResult = z.infer<typeof AccountSearchResultModel>;

export type AccountProfileMessage = Required<ConfigDrivenProfileMessage>;
